// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"f1449453","241":"cc0fa589","543":"d5ccc142","611":"f67a673b","705":"e0aebe9f","786":"24606fbf","975":"522fb31b","980":"af057ff1"}[chunkId] + ".chunk.css";
};